import React, { memo } from "react";

import cn from "classnames";
import { icons } from "constants/icons";

type Props = {
  checked: boolean;
  name?: string;
  label?: string;
  onChange: (e?: any) => void;
};
export const Checkbox = memo(({ name, checked, label, onChange }: Props) => {
  return (
    <div className="flex items-center space-x-2">
      <div
        className={cn(
          "w-4 h-4 flex justify-center items-center rounded-[5px] border-2 border-[#C4C4C4] relative transition-all ",
          {
            "border-primary bg-primary": checked,
          }
        )}
      >
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          className="hideVisually"
        />
        <img src={icons.markIcon} alt="mark" />
      </div>
      {label && (
        <label htmlFor={name} className="text-grayDark text-sm cursor-pointer">
          {label}
        </label>
      )}
    </div>
  );
});
